import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Dispatch } from 'redux';
import piggy from '../../assets/temp/piggy1.png';
import { generateToken, setCPF, validateToken } from '../../store/auth/actions';
import { setTipoAcesso } from '../../store/config/actions';
import { getContacts } from '../../store/contacts/actions';
import { validateCheckUser } from '../../store/validate/actions';
import { createSession } from '../../store/analytic/actions';
import {
  Button,
  Column,
  Container,
  ContainerImage,
  ContainerInfo,
  ContainerInteraction,
  Content,
  Image,
  Input,
  Label,
  PreviewContainer,
  TagError,
  Title,
  Wrapper,
} from './styles';
import validateCnpj from '../../services/utils/validateCnpj';
import validateCpf from '../../services/utils/validateCpf';
import Toast from '../../components/Toast';
import { navigationUrl } from '../../store/analytic/actions';

const MaskedCpf: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch<Dispatch>();
  const [condition, setCondition] = useState(true);
  const [userCpf, setUserCpf] = useState('');
  const [hasPj, setHasPj] = useState(false);
  const [errorDigit, setErrorDigit] = useState(false);
  const [digits3, setDigits3] = useState('');
  const [token, setToken] = useState('');

  const user = useSelector((state: ApplicationState) => state.validate.user);
  const assessoriaName = useSelector(
    (state: ApplicationState) => state.config.assessoriaName
  );

  const { errorToken, assessoriaImage } = useSelector(
    (state: ApplicationState) => ({
      errorToken: state.validate.errorToken,
      assessoriaImage: state.config.assessoriaImage,
    })
  );

  const { hashId, campaignId } = useParams<{
    hashId: string;
    campaignId: string;
  }>();
  useEffect(() => {
    dispatch(createSession.request(campaignId));
    dispatch(validateCheckUser({ hashId, campaignId }));
    dispatch(setTipoAcesso(0));
  }, [dispatch, hashId]);

  useEffect(() => {
    setCondition(user.hasToken);
    setUserCpf(user.userCPF);
    setHasPj(user.userPJ);
  }, [user]);

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: 'CPF Mascarado',
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setErrorDigit(
      digits3 && !digits3.includes('_')
        ? hasPj
          ? !validateCnpj(user.userCPF.replace('***', digits3))
          : !validateCpf(user.userCPF.replace('***', digits3))
        : false
    );
  }, [digits3, hasPj, user]);

  const handlerDigits = (value: string, type: string): void => {
    const digits = value.replace(/\s/g, '');
    type === 'cpf' ? setDigits3(digits) : setToken(digits);
  };

  const submit = () => {
    const isComplete = digits3
      .replace(/[^0-9]/g, '')
      .replace(/(\..*)\./g, '$1');
    if (
      errorDigit ||
      !digits3 ||
      isComplete.length !== 3 ||
      (user.hasToken && !token)
    ) {
      toast.error(
        <Toast
          title={'Credenciais inválidas!'}
          description={'Por favor, verifique os seus dados e tente novamente.'}
        />
      );
    } else {
      dispatch(
        getContacts.request({ cpf: user.userCPF.replace('***', digits3) })
      );
      dispatch(setCPF(user.userCPF.replace('***', digits3)));
      dispatch(generateToken.failure(''));
      dispatch(validateToken.request(token));
      history.push('/contrato');
    }
  };
  return (
    <Wrapper>
      <Container>
        <ContainerInfo>
          <Title>Olá {user.userName},</Title>
          <Content>
            <h2>Que tal deixar todos os seus débitos para trás agora mesmo?</h2>
            <p>
              Esta oferta faz parte da campanha da {assessoriaName} para
              facilitar a quitação de suas dívidas. Para continuar, complete os
              3 dígitos do seu CPF ou CNPJ abaixo:
            </p>
          </Content>
          <PreviewContainer sizeMargin={condition}>
            <span>{userCpf}</span>
          </PreviewContainer>

          <ContainerInteraction>
            <Column id='cpf'>
              {condition && (
                <Label>{hasPj ? 'CNPJ' : 'CPF'} (3 dígitos):</Label>
              )}
              <Input
                mask='9 9 9'
                id='cpf'
                hasToken={condition}
                alwaysShowMask={true}
                error={errorDigit}
                onChange={(e) => handlerDigits(e.target.value, 'cpf')}
              />
              {errorDigit && <TagError>CPF inválido</TagError>}
            </Column>
            {condition && (
              <Column id='token'>
                <Label>TOKEN:</Label>
                <Input
                  mask='9 9 9 9 9 9'
                  id='token'
                  hasToken={condition}
                  alwaysShowMask={true}
                  error={errorToken}
                  onChange={(e) => handlerDigits(e.target.value, 'token')}
                  type='tel'
                />
                {errorToken && <TagError>Token inválido</TagError>}
              </Column>
            )}
            <Button
              hasMargin={condition}
              onClick={submit}
              disabled={digits3.length > 0 ? false : true}
            >
              Entrar
            </Button>
          </ContainerInteraction>
        </ContainerInfo>

        <ContainerImage>
          <Image src={assessoriaImage} />
        </ContainerImage>
      </Container>
    </Wrapper>
  );
};

export default MaskedCpf;
